<div class="container">
     <!-- Screen reader announcement for page title -->
	<div class="visually-hidden" tabindex="-1" #pageTitleAnnouncer role="heading" aria-level="1">
	{{ 'CHANGE_EMAIL' | globalTranslate}}
	</div>
	<div class="row">
		<!-- <nh-alert type="danger" [isOpen]="showEmailAlert" [dismissible]="true">
			{{ 'EMAIL_USED' | globalTranslate }}
		</nh-alert> -->

		<nh-alert type="danger" [isOpen]="showEmailAlert()">
			<div class="row">
				<div class="col-auto icon">
					<img src="../../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg" alt="" />
				</div>
				<div class="col message">
					<span>{{ 'EMAIL_USED' | globalTranslate }}</span>
				</div>
			</div>
		</nh-alert>
		
		<div class="card full-width-card">
			<div class="card-body">
				<section>
					<h1 class="section-header">{{'CHANGE_EMAIL' | globalTranslate }}</h1><hr>
					<p [innerHtml]="'SAVE_EMAIL' | globalTranslate"></p>
					<form [formGroup]="updateEmailFrom">
						<div class="col-md-6">
							<nh-field [isRow]="true" label="{{'CURRENT_EMAIL' | globalTranslate }}" [mandatory]="false" [attr.aria-required]="false" class="label-section">
								<input type="email" name="currentEmail" [attr.aria-label]="'CURRENT_EMAIL'| globalTranslate" [attr.disabled]="true" formControlName="currentEmail"
									class="form-control">
							</nh-field>
							<nh-field [isRow]="true" label="{{'NEW_EMAIL' | globalTranslate }}" class="label-section">
								<input type="email" name="newEmail" [attr.aria-label]="'NEW_EMAIL' | globalTranslate"
 								formControlName="newEmail" class="form-control"
									placeholder="name@example.com" required>
							</nh-field>
						</div>
					</form>
					<br><br><br><br>
				</section>
			</div>
		</div>
	</div>
</div>